import React, { useContext, useEffect, useMemo } from 'react';
import { message } from 'antd';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { PentasBrowser } from './Penta/PentasBrowser/PentasBrowser';
import { _groupAdd } from './utilsGroup';


export function GroupSelector({
  exclude,
  group = {},
  members = [],
  invited = [],
  admins = [],
  expanded,
  setExpanded = () => void (0),
  onAdd,
  fetchMembers,
  fetchInvited,
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const excludeTokens = useMemo(() => {
    if (exclude?.length) return exclude;
    return [
      ...(members || []).map(one => one.user?.token),
      ...(invited || []).map(one => one.user?.token),
      ...(admins || []).map(one => one.user?.token),
    ].filter(Boolean);
  }, [exclude, members, invited, admins]);

  useEffect(() => {
    const id = context.state.groupChooseId;
    if (!id || !group.token || id !== group.token) return;
    if (expanded !== id) setExpanded(id);
  }, [context.state.groupChooseId, group.token]);

  const close = () => {
    setExpanded(false);
    context.setState.setGroupChooseId(false);
  };

  const customHandlerInner = (userAvatar = { user: {} }) => {
    _groupAdd(expanded, userAvatar.user.token, () => {
      if (onAdd) onAdd(userAvatar);
      else {
        fetchMembers?.();
        fetchInvited?.();
      }
      close();
    })
  };

  const customHandlerInnerChosen = () => {
    message.warning($ui('group_user_already_in_group'));
  };


  return (
    <>

      <div className={expanded ? "x_pentas_panel x_pentas_panel--expanded" : "x_pentas_panel"}
        style={{ zIndex: 10000 }}
        onClick={!expanded ? () => setExpanded(false) : () => void (0)}
      >

        {Boolean(expanded) && <div
          onClick={close}
          style={{ opacity: expanded ? 1 : 0 }} className="x_pentas_panel_z"
        />}

        {Boolean(expanded) && <PentasBrowser
          title={`${$ui('group_add_title')} ${group.name}`}
          includeMe={false}
          chosen={excludeTokens}
          scope={['people']}
          customHandler={customHandlerInner}
          customHandlerChosen={customHandlerInnerChosen}
          pentaId={expanded}
          expanded={expanded}
          handleClose={close} />}


      </div>
    </>
  );
}
